import React from 'react';
import TestimonialsSection from '../components/TestimonialsSection/TestimonialsSection';
import StatsBar from '../components/StatsBar/StatsBar';
import PromoBanner from '../components/PromoBanner/PromoBanner';
import './PageHeader.css';

const ProjectsPage = () => {
  return (
    <main className="projects-page">
      {/* Page Header Hero */}
      <div className="page-header-banner">
        <div className="page-header-container">
          <span className="page-header-tag">✦ FEATURED PROJECTS & CASE STUDIES</span>
          <h1 className="page-header-title">Proven Track Record of Industrial Excellence</h1>
          <p className="page-header-subtitle">
            Discover how DEXA has transformed manufacturing facilities across aerospace, automotive, furniture, and heavy precision metal fabrication.
          </p>
        </div>
      </div>

      {/* Stats */}
      <StatsBar />

      {/* Testimonials */}
      <TestimonialsSection />

      {/* Promo Banner */}
      <PromoBanner />
    </main>
  );
};

export default ProjectsPage;
